import React from 'react';
import {Divider, Paper} from "convertupleads-theme";
import BasicButtons from './BasicButtons/BasicButtons';
import PageTitleBox from '../../../common/PageTitleBox';
import ButtonColors from './BasicButtons/ButtonColors';
import ContainedButtons from './BasicButtons/ContainedButtons';
import OutlinedButtons from './BasicButtons/OutlinedButtons';
import TextButtons from './BasicButtons/TextButtons';
import TonalButtons from './BasicButtons/TonalButtons';
import NoPaddingButtons from "./BasicButtons/NoPaddingButtons";
import RoundedButtons from "./BasicButtons/RoundedButtons";

const ButtonsPage = () => {
  return (
    <>
      <Paper elevation={0}>
        <PageTitleBox
          title={'Button'}
          description={'Buttons allow users to take actions, and make choices, with a single tap.'}
        />
        <Divider light />
        <BasicButtons />
        <ButtonColors />
        <RoundedButtons/>
        <ContainedButtons />
        <OutlinedButtons />
        <TextButtons />
        <TonalButtons />
        <NoPaddingButtons />
      </Paper>
    </>
  );
};

export default ButtonsPage;
